export default "__VITE_ASSET__DenXOep___"